<app-header [icon]="'arrow_back_ios'" (iconClickedEvent)="back()"></app-header>
<div class="container">
  <img src="/imgs/listening.png" alt="application icon using headphones">
  <div class="title">
    {{ 'sos.title' | translate }}
  </div>
  <div class="sub-title">
    <span>{{ 'sos.take_moment' | translate }}</span>
    <span>{{ 'sos.organize_emotions' | translate }}</span>
  </div>
  <div class="audio-container">
    <app-audio-player 
      [audioSrc]="this.configService.preferedLanguage() === 'en' ? '/audio/sensorial_grounding.mp3' : '/audio/ativacao_sistemas_sensoriais.mp3'"
      [title]="'sos.audio_1' | translate"
    >
    </app-audio-player>
  </div>
  <div class="audio-container">
    <app-audio-player 
      [audioSrc]="this.configService.preferedLanguage() === 'en' ? '/audio/emotional_regulation_breathing.mp3' : '/audio/respiracao_consciente.mp3'"
      [title]="'sos.audio_2' | translate"
    >
  </app-audio-player>
  </div>  
</div>